query ListAccountDeletionsPage($limit: Int, $nextToken: String, $view: String) {
  page: StreamToolsListAccountDeletionsPage(limit: $limit, nextToken: $nextToken, view: $view) {
    items {
      accountId
      status
      requestedAt
      completedAt
      wasSuspended
      steps
      accountExists
      email
      needsAction
      staffAccount
      loginKept
      scheduledAt
    }
    nextToken
  }
}
